import { render, staticRenderFns } from "./grantSegmentList.vue?vue&type=template&id=c4b274f6&"
import script from "./grantSegmentList.vue?vue&type=script&lang=js&"
export * from "./grantSegmentList.vue?vue&type=script&lang=js&"
import style0 from "./grantSegmentList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports